import { useUser } from "lib/user";

export const useIsAuthenticated = (): boolean => {
  const user = useUser();
  return user.isLoggedIn;
};
